<template>
  <div class="view pa24">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="demo-ruleForm">
      <el-form-item :label="$t('miniprogram', 'wechatPayMerchantId')" prop="merchantId">
        <el-col>
          <el-input :placeholder="isSucceed('merchantId')" v-model="ruleForm.merchantId"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'apiV2Key')" prop="key2">
        <el-col>
          <el-input :placeholder="isSucceed('key2')" v-model="ruleForm.key2"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'apiV3Key')" prop="key3">
        <el-col>
          <el-input :placeholder="isSucceed('key3')" v-model="ruleForm.key3"></el-input>
          <p>
            {{ $t('miniprogram', 'apiV3KeyDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'certificateSerialNumber')" prop="appSecret">
        <el-col>
          <el-input :placeholder="isSucceed('appSecret')" v-model="ruleForm.appSecret"></el-input>
          <p>
            {{ $t('miniprogram', 'certificateSerialDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'apiCertificate')" prop="certData">
        <el-col :lg="12" class="mb20">
          <el-upload class="upload-demo" action="" :before-upload="beforeUpload" :on-remove="onRemove"
            :on-exceed="onExceed" :limit="1">
            <el-button size="small" type="primary">{{ $t('miniprogram', 'clickToUpload') }}</el-button>
          </el-upload>
        </el-col>
        <el-col :lg="24">
          <el-button type="primary" @click="submitPayInfo">{{ $t('miniprogram', 'submitInfo') }}</el-button>
          <el-button type="danger" @click="resetAuthorization">{{ $t('miniprogram', 'deleteInfo') }}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { submitPayInfo } from '@/api/wechat'
import i18nMixin from '@/mixins/i18nMixin'

export default {
  mixins: [i18nMixin],
  props: {
    accountMap: {
      default: {}
    }
  },
  data() {
    return {
      ruleForm: {
        merchantId: '',
        key2: '',
        key3: '',
        certData: '',
        appSecret: '',
      },
      rules: {
        merchantId: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterMerchantId'), trigger: "blur" },
        ],
        key2: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterApiV2Key'), trigger: "blur" },
        ],
        key3: [
          { required: false, message: this.$t('miniprogram', 'pleaseEnterApiV3Key'), trigger: "blur" },
        ],
        certData: [
          { required: true, message: this.$t('miniprogram', 'pleaseUploadApiCertificate'), trigger: "blur" },
        ],
        appSecret: [
          { required: false, message: this.$t('miniprogram', 'pleaseEnterCertificateSerial'), trigger: "blur" },
        ],
      }
    };
  },
  created() {
    console.log("accountMap", this.accountMap)
  },
  methods: {
    beforeUpload(file) {
      const that = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        let base64Data = e.target.result;
        base64Data = base64Data.substring(base64Data.indexOf(',') + 1);
        that.ruleForm.certData = base64Data;
      };
      return false;
    },
    onRemove() {
      this.ruleForm.certData = '';
    },
    onExceed() {
      this.$message.warning(this.$t('miniprogram', 'onlyOneCertificate'))
    },
    isSucceed(type) {
      let str = this.rules[type][0].message
      if (this.accountMap.state == 1) {
        str = type == 'merchantId' ? this.accountMap.merchantId : str
      }
      return str
    },
    submitPayInfo() {
      if (!this.ruleForm.merchantId || !this.ruleForm.key2 || !this.ruleForm.certData) {
        return this.$message.error(this.$t('miniprogram', 'checkDataComplete'))
      }
      let data = {
        merchantId: this.ruleForm.merchantId,
        key: this.ruleForm.key2 + '---' + this.ruleForm.key3,
        certData: this.ruleForm.certData,
        appSecret: this.ruleForm.appSecret,
        accountType: 6 //crm支付
      }
      submitPayInfo(data)
        .then(res => {
          console.log(res);
          this.$message.success(this.$t('miniprogram', 'submitSuccess'));
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t('miniprogram', 'submitFailed'));
        })
    },
    resetAuthorization() {
      let accountId = this.accountMap.accountId
      if (!accountId) {
        this.$message.error(this.$t('miniprogram', 'notSubmittedMerchantInfo'))
        return
      }
      this.$emit('resetAuthorization', accountId)
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-upload--text {
  background-color: #fff;
  border: 0px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 84px;
  height: 34px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-input {
  width: 500px;
}
</style>
